import { Add, ArrowDropDown } from '@mui/icons-material';
import { Menu, MenuItem } from '@mui/material';
import { DateTime } from 'luxon';
import { useState } from 'react';

import { Button } from '@/components/Button';
import { paperStyles } from '@/components/Selector/styles';
import { CurrentUserOnlyGuard } from '@/features/CurrentUserOnlyGuard';
import { modalManagerStore } from '@/features/ModalManagerStore';
import { MuiColors } from '@/types/colors';

const AddLogButton = () => {
  const todayDate = DateTime.local();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        variant="contained"
        sx={{
          borderColor: MuiColors.accentColor,
          color: MuiColors.additionalColor,
          borderRadius: '6px',
          boxShadow: 'none',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
        }}
      >
        <Add sx={{ width: '18px' }} />
        <p>Добавить</p>
        <ArrowDropDown sx={{ width: '18px' }} />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: { sx: paperStyles },
          list: { sx: { py: '6px' } },
        }}
      >
        <MenuItem
          sx={{ borderRadius: '8px', mx: 1 }}
          onClick={() => {
            modalManagerStore.open('addLog', { date: todayDate });
            handleClose();
          }}
        >
          Создать лог
        </MenuItem>
        <CurrentUserOnlyGuard>
          <MenuItem
            sx={{ borderRadius: '8px', mx: 1 }}
            onClick={() => {
              modalManagerStore.open('addDraft', { date: todayDate });
              handleClose();
            }}
          >
            Создать черновик
          </MenuItem>
        </CurrentUserOnlyGuard>
      </Menu>
    </>
  );
};

export default AddLogButton;
